import { Form, Row, Col, Button } from 'react-bootstrap';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
//import { useLocation } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../Products/ProductForm.css'
import { TextInput, TextAreaInput, BrandSelectInput } from '../Misc/FormInput';
import { VendorSelection } from '../Products/ProductFormSimpleSections';
import { authFetch } from '../Auth/apiClient'
import { useMsal } from '@azure/msal-react';
import '../Misc/FormInput.css'
import './CampaignProductForm.css'

const COOP_OPTIONS = [
    {
        label: 'NO Co-op Program',
        value: 'NO Co-op program',
        values: ['NO Co-op program', 'NO Co-op program-Track Expense'],
    },
    {
        label: 'YES Co-op, Send Invoice',
        value: 'YES Co-op, Send Invoice',
        values: ['YES Co-op by Invoice', 'YES Co-op, Send Invoice'],
    },
    {
        label: 'YES Co-op, Do Not Send Invoice',
        value: 'YES Co-op, Do Not Send Invoice',
        values: ['yesCoopDFI', 'YES Co-op DFI %', 'YES Co-op installment-Track Expenses', 'YES Co-op, Do Not Send Invoice'],
    },
];

const CampaignProductFormRefactor = ({productFormState, handleProductFormChange, saveProduct, isNew, brands, setProductFormState, vens, selected, buyer_responsible}) => {
    const { instance } = useMsal();
    /*const [userName, setUserName] = useState('');
    const handleUserNameChange = (event) => {
        setUserName(event.target.value);
    };
    useEffect(() => {
        const userInfo = getUserInfo(instance);
        setUserName(userInfo.name || '');
    }, [instance]);*/

    


    const [newImageState, setNewImageState] = useState({"currentlyLive": "", "currentlyLiveCheck": false, "sentToVendor": "", "sentToVendorCheck": false, "comments": "", "commentsCheck": false});

    const venSelect = Object.values(vens);

    const submitButton = {
        button: 'saveAndReplace'
    }

    const handleNewImageFormChange = (event) => {
        const { target: {name, value} } = event;
        setNewImageState({...newImageState, [name]: value});
    }

    const handleProductFormSubmit = (event) =>  {
        event.preventDefault();
        let submitData = { ...productFormState };
        if (productFormState.product_id === "") {
            if (newImageState.currentlyLive === "" &&
                newImageState.sentToVendor === "" &&
                newImageState.comments === ""
            ) {
                alert("Please fill out one of the PRODUCT IMAGE STATUS options.")
                return
            } else {
                let imageComments = submitData.comments || '';
                if (newImageState.currentlyLive !== "") {
                    imageComments += '\nImage URL: ' + newImageState.currentlyLive;
                }
                if (newImageState.sentToVendor !== "") {
                    imageComments += '\nPPL sent to vndor, date: ' + newImageState.sentToVendor;
                }
                if (newImageState.comments !== "") {
                    imageComments += '\nImage Comments: ' + newImageState.comments;
                }
                submitData = { ...submitData, comments: imageComments };
            }
        }
        //console.log(submitButton.button);
        //return
        //console.log(productFormState);
        //submitData.userName = userName;
        if (submitButton.button === 'saveAndReplace') {
            // New path: upsert to products table, then save reference to campaign
            // product_id is preserved (or assigned by backend for new products)
            authFetch(instance, '/api/upsert_product', {
                "method": "POST",
                "headers": {"Content-Type": "application/json"},
                "body": JSON.stringify(submitData),
            }).then(function(res) {
                return res.json();
            }).then(function(data) {
                // If a new product was created, capture the product_id from response
                let payloadToSave = { ...submitData };
                const createdProductId = data?.product_id || data?.lastrowid;
                if (createdProductId) {
                    payloadToSave = { ...payloadToSave, product_id: createdProductId };
                }
                setProductFormState(payloadToSave);
                saveProduct(payloadToSave);
            }).catch(function(error) {
                alert('There was an error connecting to the database, please refresh the page.');
                return;
            });
            return; // Don't call saveProduct() below, it's called in .then()
        }
        if (submitButton.button === 'saveToFlyer') {
            // Legacy path: only for old campaigns with product_id === 0
            submitData = { ...submitData, product_id: 0 };
        }
        
        setProductFormState(submitData);
        saveProduct(submitData);
    }

    const [skuList, setSkuList] = useState('');
    const [autoFillFormState, setAutoFillFormState] = useState({});
    const [autoFillLoading, setAutoFillLoading] = useState(false);
    const previousVendorIdsRef = useRef('');
    const previousCoopIdsRef = useRef('');

    /* Clear out the data cache when the selected grid changes (otherwise, once there are autofill results
    * they will be persistent until there are new results or the page is refreshed)
    */
    useEffect(() => {
        setAutoFillFormState({});
        setSkuList('');
    }, [selected]);

    const parseVendorIds = (vendorString) => {
        return (vendorString || '')
            .split(',')
            .map((id) => id.trim().toLowerCase())
            .filter((id) => id.length > 0);
    };

    const hasCoopEnabledVendor = useMemo(() => {
        const vendorIds = parseVendorIds(productFormState.vendor_id);
        return vendorIds.some((vid) => vens[vid]?.coop?.toLowerCase() === 'yes');
    }, [productFormState.vendor_id, vens]);

    const hasLegacyCoopDivergence = useMemo(() => {
        const vendorIds = parseVendorIds(productFormState.vendor_id);
        const coopIds = parseVendorIds(productFormState.coop_vendor_code);
        const previousVendorIds = parseVendorIds(previousVendorIdsRef.current);
        if (coopIds.length === 0) {
            return false;
        }
        if (JSON.stringify(coopIds) === JSON.stringify(previousVendorIds)) {
            return false;
        }
        return JSON.stringify(vendorIds) !== JSON.stringify(coopIds);
    }, [productFormState.vendor_id, productFormState.coop_vendor_code]);

    const normalizedVendorIds = useMemo(
        () => parseVendorIds(productFormState.vendor_id).join(', '),
        [productFormState.vendor_id]
    );

    const normalizedCoopVendorIds = useMemo(
        () => parseVendorIds(productFormState.coop_vendor_code).join(', '),
        [productFormState.coop_vendor_code]
    );

    const shouldShowCoopSection = useMemo(() => {
        return hasCoopEnabledVendor || hasLegacyCoopDivergence;
    }, [hasCoopEnabledVendor, hasLegacyCoopDivergence]);

    const shouldShowCoopVendorAboveVendor = useMemo(() => {
        return shouldShowCoopSection && normalizedVendorIds === '' && normalizedCoopVendorIds !== '';
    }, [normalizedCoopVendorIds, normalizedVendorIds, shouldShowCoopSection]);

    useEffect(() => {
        const currentVendorIds = productFormState.vendor_id;
        const currentCoopIds = productFormState.coop_vendor_code;
        const prevVendorIds = previousVendorIdsRef.current;
        const prevCoopIds = previousCoopIdsRef.current;

        if (currentVendorIds !== prevVendorIds) {
            const coopIdsParsed = parseVendorIds(currentCoopIds);
            const prevIdsParsed = parseVendorIds(prevVendorIds);

            if (coopIdsParsed.length === 0 || JSON.stringify(coopIdsParsed) === JSON.stringify(prevIdsParsed)) {
                setProductFormState((prev) => ({
                    ...prev,
                    coop_vendor_code: currentVendorIds,
                }));
                previousCoopIdsRef.current = currentVendorIds;
            }

            previousVendorIdsRef.current = currentVendorIds;
        } else if (currentCoopIds !== prevCoopIds) {
            previousCoopIdsRef.current = currentCoopIds;
        }
    }, [productFormState.vendor_id, productFormState.coop_vendor_code, setProductFormState]);

    function dataFromAutoFill(key) {
        //console.log('I can see', productFormState);
        setProductFormState({...productFormState, [key]: autoFillFormState[key]});
        //console.log(key, autoFillFormState[key]);
        //console.log(autoFillFormState);
        //setProductFormState(autoFillFormState.key);
        let tempAutofillState = { ...autoFillFormState};
        delete tempAutofillState[key]
        if (key+'_name' in tempAutofillState) {
            delete tempAutofillState[key+'_name']
        }
        setAutoFillFormState(tempAutofillState);
    }

    function queryAutoFill() {
        setAutoFillLoading(true);
        authFetch(instance, '/api/autofill_product', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify({"skus": skuList}),
        }).then(function(res) {
            return res.json()
        }).then((data) => {
            //console.log(data);
            if ('status' in data) {
                if (data.status === 404) {
                    alert('No product data found.')
                } else {
                    alert('Bad request - SKU list should be composed of SKUs separated by commas.');
                }
                setAutoFillLoading(false);
                return
            }
            //console.log(data);
            let tempProductFormState = { ...productFormState};
            let tempAutofillState = {};
            Object.keys(data).forEach(function(key) {
                
                if (key.includes('brand')) {
                    let found_brand = brands.find((brand) => brand.name.toLowerCase() === data[key].toLowerCase());
                    if (found_brand) {
                        data[key] = found_brand.id;
                        tempAutofillState[key+'_name'] = found_brand.name;
                    }
                }
                tempAutofillState[key] = data[key];
                tempProductFormState[key] = data[key];
            });
            console.log(tempAutofillState);
            tempAutofillState.buyer_responsible = buyer_responsible;
            if (productFormState.product_id === "") {
                setProductFormState(tempProductFormState);
            } else {
                setAutoFillFormState(tempAutofillState);
            }
            setAutoFillLoading(false);
        });
    }

    const convertVens = useCallback(() => {
        const vendorIds = parseVendorIds(productFormState.vendor_id);
        if (vendorIds.length > 0 && !productFormState.coop_vendor_code) {
            const firstVendor = vens[vendorIds[0]];
            if (firstVendor?.coop) {
                let coopValue = 'NO Co-op program';
                if (firstVendor.coop.toLowerCase() === 'yes') {
                    coopValue = firstVendor.policy?.toLowerCase().includes('invoice')
                        ? 'YES Co-op, Send Invoice'
                        : 'YES Co-op, Do Not Send Invoice';
                }
                setProductFormState((prev) => ({ ...prev, coop_eligible: coopValue }));
            }
        }
    }, [productFormState.vendor_id, productFormState.coop_vendor_code, vens, setProductFormState]);

    useEffect(() => {
        convertVens();
    }, [convertVens]);

    const coopVendorIsRequired = !["NO Co-op program", "NO Co-op program-Track Expense", ''].includes(productFormState.coop_eligible);

    const coopEligibilitySection = shouldShowCoopSection ? (
        <div>
            <Col xs={8} className="d-flex mb-2">
                <h5 className="text-start">CO-OP ELIGIBILITY:<span style={{color: "red", fontWeight: "bold", fontSize: 18}}>*</span></h5>
            </Col>
            <VendorSelection
                formState={productFormState}
                setFormState={setProductFormState}
                fieldName="coop_vendor_code"
                inputLabel="Co-op Vendor ID:"
                asterisk={coopVendorIsRequired}
                placeholder={coopVendorIsRequired ? "(Required)" : ""}
                vendors={venSelect}
            />

            <Row>
                <Col xs={5} className="mb-3 align-items-center text-start">
                    <Form.Label className='formInput'>
                        Pre-approval Required
                    </Form.Label>
                    &nbsp;&nbsp;&nbsp;
                    <input
                        type="checkbox" className="pre_approval_checkbox"
                        name="coop_pre_approval"
                        onChange={handleProductFormChange}
                        checked={productFormState.coop_pre_approval}>
                    </input>
                </Col>
            </Row>

            <Form.Group as={Row} className="mb-3 text-start ms-1">
            {COOP_OPTIONS.map((option, index) => (
                <Col lg={7} key={index}>
                    <Form.Check name="coop_eligible" inline type="radio" onChange={handleProductFormChange} value={option.value} label={option.label} checked={option.values.includes(productFormState.coop_eligible)}></Form.Check>
                </Col>
            ))}
            </Form.Group>
            <TextAreaInput inputName="coop_comments" inputLabel="Co-op Comments:" inputValue={productFormState.coop_comments} changeFunc={handleProductFormChange}/>
        </div>
    ) : null;


    return (
        <Row>
        <Row  className="mb-3 ">
            <Col>
                <Form.Label>Autofill (input list of skus separated by commas)</Form.Label>
            </Col>
            <Col>
                <Form.Control
                    value={skuList}
                    onChange={(e) => setSkuList(e.target.value)}    
                ></Form.Control>
            </Col>
            <Col>
                <Button
                    style={{backgroundColor: "#a73c21", color: "#ffffff", textDecoration: "underline #a73c21", borderRadius: "0px",
                    borderColor: "#a73c21"}}
                    onClick={() => queryAutoFill()}
                >Search and Autofill</Button>
            </Col>
            <Row style={{display: autoFillLoading ? '' : 'none'}}>
                <Col className='offset-4 mt-2 text-start'>
                    <p>Loading results...</p>
                </Col>
            </Row>
            <Col xs={12}>
                <hr/>
            </Col>
        </Row>
        <Col className='border-start border-end'>
        <Form onSubmit={handleProductFormSubmit}>
            {/* REQUIRED PRODUCT IDENTIFICATION INPUTS */}
            <TextInput inputName="sku" inputLabel="SKU/Item #:"
            asterisk={true}
            placeholder={"(Required)"}
            inputValue={productFormState.sku} inputRequired={true} changeFunc={handleProductFormChange}
            autoFillInfo={('sku' in autoFillFormState)
                ? {'value': autoFillFormState.sku,
                    'fill': () => dataFromAutoFill('sku')
                }
                : null
            }/>
            <Col className="text-start">
                <p>Manufacturer part # used by designers to find images, list PNs for items you want have pictured.</p>
            </Col>
            <TextInput inputName="manufacturer_num" inputLabel="Manufacturer part #:"
            asterisk={true}
            placeholder={"(Required)"}
            inputValue={productFormState.manufacturer_num} inputRequired={true} changeFunc={handleProductFormChange}
            autoFillInfo={('manufacturer_num' in autoFillFormState)
                ? {'value': autoFillFormState.manufacturer_num,
                    'fill': () => dataFromAutoFill('manufacturer_num')
                }
                : null}
            />
            {/* IMAGE FIELDS FOR NEW PRODUCTS */}
            <Row style={{paddingTop: "15px", backgroundColor: "#ffe5f6", display: productFormState.product_id==="" ? "block" : "none"}}>
                <Col xs={8} className="d-flex">
                    <h5 className="text-start">PRODUCT IMAGE STATUS</h5>
                    <p>&nbsp;&nbsp;&nbsp;(MUST SELECT ONE):<span style={{color: "red", fontWeight: "bold", fontSize: 18}}>*</span></p>
                </Col>
                <Row>
                    <Col xs={8}>
                        {/*<Form.Check readOnly checked={newImageState.currentlyLive !== ""} className="formInput" type="checkbox" label="Product is currently live on murdochs.com:" style={{textAlign: "start", textDecoration: "none"}}/>*/}
                        <Form.Check name="currentlyLiveCheck" checked={newImageState.currentlyLiveCheck} className="formInput" type="checkbox" label="Product is currently live on murdochs.com:" style={{textAlign: "start", textDecoration: "none"}} onChange={() => setNewImageState({...newImageState, 'currentlyLiveCheck': !newImageState.currentlyLiveCheck})}/>
                    </Col>
                    <TextInput inputName="currentlyLive" inputLabel="URL:" inputValue={newImageState.currentlyLive} inputRequired={false} changeFunc={handleNewImageFormChange}/>
                </Row>
                <Row>
                    <Col xs={8}>
                        {/*<Form.Check readOnly checked={newImageState.sentToVendor !== ""} className="formInput" type="checkbox" label="PPL has been sent to vendor" style={{textAlign: "start", textDecoration: "none"}}/>*/}
                        <Form.Check checked={newImageState.sentToVendorCheck} className="formInput" type="checkbox" label="PPL has been sent to vendor" style={{textAlign: "start", textDecoration: "none"}} onChange={() => setNewImageState({...newImageState, 'sentToVendorCheck': !newImageState.sentToVendorCheck})}/>
                    </Col>
                    <TextInput inputName="sentToVendor" inputLabel="Date Sent:" inputValue={newImageState.sentToVendor} inputRequired={false} changeFunc={handleNewImageFormChange}/>
                </Row>
                <Row>
                    <Col xs={8}>
                        {/*<Form.Check readOnly checked={newImageState.comments !== ""} className="formInput" type="checkbox" label="Notes for designer on product image status:" style={{textAlign: "start", textDecoration: "none"}}/>*/}
                        <Form.Check checked={newImageState.commentsCheck} className="formInput" type="checkbox" label="Notes for designer on product image status:" style={{textAlign: "start", textDecoration: "none"}} onChange={() => setNewImageState({...newImageState, 'commentsCheck': !newImageState.commentsCheck})}/>
                    </Col>
                    <TextAreaInput inputName="comments" inputLabel="Comments:" inputValue={newImageState.comments} changeFunc={handleNewImageFormChange}/>
                </Row>
            </Row>
            <br></br>

            {/* CONTINUED REQUIRED FIELDS */}
            <TextInput inputName="in_stock_sku_list" inputLabel="In-Stock - Dynamics Item IDs" //inputLabel="In-Stock SKU List"
            asterisk={true}
            placeholder={"(Required)"}
            inputValue={productFormState.in_stock_sku_list} inputRequired={true} changeFunc={handleProductFormChange}
            autoFillInfo={('in_stock_sku_list' in autoFillFormState)
                ? {'value': autoFillFormState.in_stock_sku_list,
                    'fill': () => dataFromAutoFill('in_stock_sku_list')
                }
                : null}
            />
            <TextInput inputName="display_sku" inputLabel="Printed SKU/Item #:"
            asterisk={true}
            placeholder={"(Required)"}
            inputValue={productFormState.display_sku} inputRequired={true} changeFunc={handleProductFormChange}
            autoFillInfo={('display_sku' in autoFillFormState)
                ? {'value': autoFillFormState.display_sku,
                    'fill': () => dataFromAutoFill('display_sku')
                }
                : null}
            />
            <TextInput inputName="name" inputLabel="Printed Name:"
            asterisk={true}
            placeholder={"(Required)"}
            inputValue={productFormState.name} inputRequired={true} changeFunc={handleProductFormChange}
            />

            {/* SYMBOL COPYING ROW */}
            <Row className="mb-3 align-items-center text-start">
            <Form.Label column xs={3} className="formInput" style={{paddingLeft: "2%", fontSize: "20px"}}>Click to Copy:</Form.Label>
                <Col xs={1} className="d-grid">
                    <button type="button" onClick={() => {navigator.clipboard.writeText('®')}}>®</button>
                    {/*<button type="button" onClick={() => {navigator.clipboard.writeText('®')}}>®</button>*/}
                </Col> 
                <Col xs={1} className="d-grid">
                    <button type="button" onClick={() => {navigator.clipboard.writeText('™')}}>™</button>
                </Col>
                <Col xs={1} className="d-grid">
                    <button type="button" onClick={() => {navigator.clipboard.writeText('½')}}>½</button>
                </Col>
                <Col xs={1} className="d-grid">
                    <button type="button" onClick={() => {navigator.clipboard.writeText('¼')}}>¼</button>
                </Col>
                <Col xs={1} className="d-grid">
                    <button type="button" onClick={() => {navigator.clipboard.writeText('¾')}}>¾</button>
                </Col>
            </Row>

            {/* BRAND SELECT INPUTS */}
            <BrandSelectInput inputName="brand_id" inputLabel="Brand:" inputValue={productFormState.brand_id} changeFunc={handleProductFormChange} selectOptions={brands}
            autoFillInfo={('brand_id' in autoFillFormState)
            ? {'value': autoFillFormState.brand_id,
                'name': autoFillFormState.brand_id_name,
                'fill': () => dataFromAutoFill('brand_id')
            }
            : null}/>
            <BrandSelectInput inputName="brand_id_2" inputLabel="Brand 2:" inputValue={productFormState.brand_id_2} changeFunc={handleProductFormChange} selectOptions={brands}
            autoFillInfo={('brand_id_2' in autoFillFormState)
            ? {'value': autoFillFormState.brand_id,
                'name': autoFillFormState.brand_id_2_name,
                'fill': () => dataFromAutoFill('brand_id_2')
            }
            : null}/>
            <BrandSelectInput inputName="brand_id_3" inputLabel="Brand 3:" inputValue={productFormState.brand_id_3} changeFunc={handleProductFormChange} selectOptions={brands}
            autoFillInfo={('brand_id_3' in autoFillFormState)
            ? {'value': autoFillFormState.brand_id,
                'name': autoFillFormState.brand_id_3_name,
                'fill': () => dataFromAutoFill('brand_id_3')
            }
            : null}/>
            <BrandSelectInput inputName="brand_id_4" inputLabel="Brand 4:" inputValue={productFormState.brand_id_4} changeFunc={handleProductFormChange} selectOptions={brands}
            autoFillInfo={('brand_id_4' in autoFillFormState)
            ? {'value': autoFillFormState.brand_id_4,
                'name': autoFillFormState.brand_id_4_name,
                'fill': () => dataFromAutoFill('brand_id_4')
            }
            : null}/>

            {/* REQUIRED VENDOR ID INPUT */}
            {/*<Col className="text-start">
                <p>Marketing does not have access to VEN number, enter Vendor Name.</p>
        </Col>*/}
            <hr/>
            <Row className="mb-2 text-start">
                <Col xs={11}>
                    <p className="mb-0">
                        At least one vendor must be selected
                    </p>
                </Col>
            </Row>
            {shouldShowCoopVendorAboveVendor && coopEligibilitySection}
            <VendorSelection
                formState={productFormState}
                setFormState={setProductFormState}
                fieldName="vendor_id"
                inputLabel="Vendor ID:"
                asterisk={true}
                placeholder="(Required - select vendors from the dropdown to add to the list)"
                vendors={venSelect}
            />
            {shouldShowCoopSection && !shouldShowCoopVendorAboveVendor && coopEligibilitySection}
            <hr/>

            {/* PROMOTIONAL INPUTS */}
            <TextInput inputName="sale_header" inputLabel={`"Your Choice" Header:`} inputValue={productFormState.sale_header} changeFunc={handleProductFormChange}/>
            <TextInput inputName="save" inputLabel="Save Circle:" inputValue={productFormState.save} inputInfo='Formatting examples: "Save 15%", "Save $10"' changeFunc={handleProductFormChange}/>

            {/* PRICING INPUTS */}
            <hr/>
            <Col xs={8} className="d-flex">
                <h5 className="text-start">Flyer Pricing</h5>
            </Col>
            <TextInput inputName="sale_price" inputLabel="Sale Price:" inputValue={productFormState.sale_price} inputInfo='Formatting examples: "11.99", "SAVE 15%", "SAVE $10"' changeFunc={handleProductFormChange}/>
            <TextInput inputName="regular_price" inputLabel="Regular Price:" inputValue={productFormState.regular_price} inputInfo='Formatting examples: "19.99", "2.99-6.99", "Reg $19.99 a pair"' changeFunc={handleProductFormChange}
            autoFillInfo={('regular_price' in autoFillFormState)
                ? {'value': autoFillFormState.regular_price,
                    'fill': () => dataFromAutoFill('regular_price')
                }
                : null}
            />
            <hr/>
            

            {/* MAP Override inputs */}
            <Col xs={8} className="d-flex">
                <h5 className="text-start">MAP Override for Sale Signs</h5>
                <p>&nbsp;&nbsp;&nbsp;(Leave blank to pull pricing from Flyer Regular Price)</p>
            </Col>
            <TextInput inputName="sale_price_map" inputLabel="Sale Price:" inputValue={productFormState.sale_price_map} inputInfo='Formatting examples: "11.99", "Save 15%", "Save $10"' changeFunc={handleProductFormChange}/>
            <TextInput inputName="regular_price_map" inputLabel="Regular Price:" inputValue={productFormState.regular_price_map} inputInfo='Formatting examples: "19.99", "2.99-6.99", "Reg $19.99 a pair"' changeFunc={handleProductFormChange}
            autoFillInfo={('regular_price_map' in autoFillFormState)
                ? {'value': autoFillFormState.regular_price_map,
                    'fill': () => dataFromAutoFill('regular_price_map')
                }
                : null}
            />
            <hr/>

            {/* PRODUCT INFORMATION INPUTS */}
            <TextInput inputName="hires_image_name" inputLabel="Hi-Res Image Path:" inputValue={productFormState.hires_image_name} changeFunc={handleProductFormChange}/>
            <TextInput inputName="hires_image_name_2" inputLabel="Hi-Res Image Path 2:" inputValue={productFormState.hires_image_name_2} changeFunc={handleProductFormChange}/>
            <TextInput inputName="hires_image_name_3" inputLabel="Hi-Res Image Path 3:" inputValue={productFormState.hires_image_name_3} changeFunc={handleProductFormChange}/>
            
            <Row>
                <span className="text-start mb-2" style={{color: "#a73c21", fontWeight: "300", fontSize: "15px", marginLeft: "8px"}}>
                    FOR DESIGN ONLY - Check when all image paths are entered
                </span>
            </Row>
            <Row>
                <Col xs={8} className="align-items-center text-start">
                    <Form.Label className='formInput'>
                        Product Finalized
                    </Form.Label>
                    &nbsp;&nbsp;&nbsp;
                    <input
                        type="checkbox" className="pre_approval_checkbox"
                        name="product_finalized"
                        onChange={handleProductFormChange}
                        checked={productFormState.product_finalized}>
                    </input>
                </Col>
            </Row>
            <hr/>

            <TextInput inputName="bullet1" inputLabel="Bullet Point 1:" inputValue={productFormState.bullet1} changeFunc={handleProductFormChange}/>
            <TextInput inputName="bullet2" inputLabel="Bullet Point 2:" inputValue={productFormState.bullet2} changeFunc={handleProductFormChange}/>
            <TextInput inputName="bullet3" inputLabel="Bullet Point 3:" inputValue={productFormState.bullet3} changeFunc={handleProductFormChange}/>
            <TextInput inputName="bullet4" inputLabel="Bullet Point 4:" inputValue={productFormState.bullet4} changeFunc={handleProductFormChange}/>
            {/*<TextInput inputName="bullet5" inputLabel="Bullet Point 5:" inputValue={productFormState.bullet5} changeFunc={handleProductFormChange}/>*/}
            <TextInput inputName="disclaimer" inputLabel="Disclaimer:" inputValue={productFormState.disclaimer} changeFunc={handleProductFormChange}/>
            <TextAreaInput inputName="comments" inputLabel="Comments:" inputValue={productFormState.comments} changeFunc={handleProductFormChange}/>
            <hr/>

            {/* USER INFORMATION */}
            <TextInput inputName="buyer_responsible" inputLabel="Buyer Responsible:" placeholder={"Enter your name"} inputValue={productFormState.buyer_responsible} changeFunc={handleProductFormChange}/>
            <hr/>
            {/*<Form.Group as={Row} className="mb-3 align-items-center text-start">
                <Form.Label column xs={3} className="formInput">Buyer Responsible:</Form.Label>
                <Col xs={7} className="text-start">
                    <Form.Control
                        type="text"
                        value={buyerResponsible}
                        onChange={handleUserNameChange}
                        placeholder="Enter your name"
                    />
                </Col>
            </Form.Group>*/}

            {/* SAVE PRODUCT */}
            <TextInput inputName="hint" inputLabel="Reference Hint:"
            asterisk={true}
            placeholder={"(Required)"}
            inputRequired={true} inputValue={productFormState.hint} changeFunc={handleProductFormChange} />

            {/* Legacy save: only shown for old campaign products with product_id === 0 */}
            <div style={{display: (productFormState.product_id === 0) ? "block" : "none"}}>
                <div style={{display: 'flex'}} className="text-start">
                    <h5>Save Product</h5>&nbsp;&nbsp;&nbsp;
                    <p>Save Product to this Campaign (changes made will not be searchable in the future)</p>
                </div>
                <Form.Group as={Row} className="mb-3 text-start">
                    <Col lg={5} className="text-start productFormLabel">
                        <Button onClick={() => submitButton.button="saveToFlyer"} type="submit" style={{backgroundColor: '#a73c21'}}>Save for Campaign</Button>
                    </Col>
                </Form.Group>
            </div>

            {/* New save: shown for all products that are not legacy (product_id !== 0) */}
            <div style={{display: (productFormState.product_id !== 0) ? "block" : "none"}}>
                <div style={{display: 'flex'}} className="text-start">
                    <h5>Save Product</h5>&nbsp;&nbsp;&nbsp;
                    <p>Update Product and save to this Campaign (searchable in future campaigns)</p>
                </div>
                <Form.Group as={Row} className="mb-3 text-start">
                    <Col lg={5} className="text-start productFormLabel">
                        <Button onClick={() => submitButton.button="saveAndReplace"} type="submit" style={{backgroundColor: '#a73c21'}}>Save and Update</Button>
                    </Col>
                </Form.Group>
            </div>
        </Form>
        </Col></Row>
    );
}
 
export default CampaignProductFormRefactor;
